import config from "config";
import { APICore } from "helpers/api/apiCore";
import { BulkBulkBuyerSellerFileDetail, BulkBulkBuyerSellerFileVersionType, BulkBuyerSellerDownloadFileType, BulkBuyerSellerFileCheckerRemarkType, BulkBuyerSellerFileMakerRemarkType, uploadBulkBuyerSellerFile } from "./types";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function uploadBulkBuyerSellersFileApi(params: uploadBulkBuyerSellerFile) {
    let formData = new FormData();
    formData.append("file", params.bulkBuyerSellerFile);
    formData.append("programm_external_id", params.programmeExtId);

    let backendApiUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship`;
    const baseUrl = backendApiUrl;

    return api.create(`${baseUrl}`, formData);
}

function fetchBulkBuyerSellersApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship`;
    return api.get(`${baseUrl}`, params);
}

function downloadBulkBuyerSellersFileApi(params: BulkBuyerSellerDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, {});
}

function fetchBulkBuyerSellersFileDetailApi(params: BulkBulkBuyerSellerFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship/${params.externalID}`;
    return api.get(`${baseUrl}`, {});
}

function fetchBulkBuyerSellersFileVersionApi(params: BulkBulkBuyerSellerFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function bulkBuyerSellersFilePublishApi(params: BulkBuyerSellerFileMakerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function approveBulkBuyerSellersFileApi(params: BulkBuyerSellerFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}
function rejectBulkBuyerSellersFileApi(params: BulkBuyerSellerFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function fetchBulkFileSpecificBuyerSellersApi(params: BulkBulkBuyerSellerFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer_relationship/${params.externalId}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}

function deleteBulkBuyerSellersFileApi(params: BulkBulkBuyerSellerFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}

export {
    uploadBulkBuyerSellersFileApi,
    fetchBulkBuyerSellersApi,
    downloadBulkBuyerSellersFileApi,
    fetchBulkBuyerSellersFileDetailApi,
    fetchBulkBuyerSellersFileVersionApi,
    bulkBuyerSellersFilePublishApi,
    approveBulkBuyerSellersFileApi,
    rejectBulkBuyerSellersFileApi,
    fetchBulkFileSpecificBuyerSellersApi,
    deleteBulkBuyerSellersFileApi
}